var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.report_builder") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("p", { staticClass: "builder-intro" }, [
                      _vm._v(
                        "\n            Créez un rapport personnalisé : choisissez les indicateurs, appliquez les filtres, puis générez-le à la demande ou planifiez son envoi automatique aux destinataires autorisés.\n          "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-4", attrs: { cols: "12", lg: "5" } },
                    [
                      _c(
                        "b-card",
                        [
                          _c("h5", { staticClass: "builder-section-title" }, [
                            _vm._v(
                              "1. " +
                                _vm._s(_vm.$t("mandate.report_builder.emitter"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedEmitter,
                                  expression: "selectedEmitter",
                                },
                              ],
                              staticClass: "filter-item-content w-100 mb-4",
                              staticStyle: { padding: "0.35rem" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedEmitter = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "Tous" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "mandate.report_builder.all_emitters_consolidated"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.entityOptions, function (e) {
                                return _c(
                                  "option",
                                  { key: e, domProps: { value: e } },
                                  [_vm._v(_vm._s(e))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "builder-hint" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "mandate.report_builder.emitter_access_hint"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-4" }),
                          _vm._v(" "),
                          _c("h5", { staticClass: "builder-section-title" }, [
                            _vm._v(
                              "2. " +
                                _vm._s(
                                  _vm.$t(
                                    "mandate.report_builder.indicators_columns"
                                  )
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "indicator-grid" },
                            _vm._l(_vm.availableIndicators, function (ind) {
                              return _c(
                                "b-form-checkbox",
                                {
                                  key: ind.key,
                                  staticClass: "mb-2",
                                  attrs: { value: ind.key },
                                  model: {
                                    value: _vm.selectedIndicators,
                                    callback: function ($$v) {
                                      _vm.selectedIndicators = $$v
                                    },
                                    expression: "selectedIndicators",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(ind.label) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-4" }),
                          _vm._v(" "),
                          _c("h5", { staticClass: "builder-section-title" }, [
                            _vm._v(
                              "3. " +
                                _vm._s(_vm.$t("mandate.report_builder.filters"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "filter-item-title d-block mb-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.report_builder.start_date"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: { type: "date", size: "sm" },
                                    model: {
                                      value: _vm.dateBeginFilter,
                                      callback: function ($$v) {
                                        _vm.dateBeginFilter = $$v
                                      },
                                      expression: "dateBeginFilter",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "filter-item-title d-block mb-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.report_builder.end_date"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: { type: "date", size: "sm" },
                                    model: {
                                      value: _vm.dateEndFilter,
                                      callback: function ($$v) {
                                        _vm.dateEndFilter = $$v
                                      },
                                      expression: "dateEndFilter",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c("b-col", { attrs: { cols: "6" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mandate.report_builder.status")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.statusFilter,
                                        expression: "statusFilter",
                                      },
                                    ],
                                    staticClass: "filter-item-content w-100",
                                    staticStyle: { padding: "0.35rem" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.statusFilter = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "Tous" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.report_builder.all_statuses"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.statusOptions, function (s) {
                                      return _c(
                                        "option",
                                        {
                                          key: s.value,
                                          domProps: { value: s.value },
                                        },
                                        [_vm._v(_vm._s(s.label))]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "6" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "mandate.report_builder.group_by"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.groupBy,
                                        expression: "groupBy",
                                      },
                                    ],
                                    staticClass: "filter-item-content w-100",
                                    staticStyle: { padding: "0.35rem" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.groupBy = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "emitter" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.emitter"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "month" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.month"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "status" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.status"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c("b-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mandate.report_builder.sort_by")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.sortBy,
                                        expression: "sortBy",
                                      },
                                    ],
                                    staticClass: "filter-item-content w-100",
                                    staticStyle: { padding: "0.35rem" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.sortBy = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "date_desc" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.date_newest_first"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "date_asc" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.date_oldest_first"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "amount_desc" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.amount_highest_first"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-4" }),
                          _vm._v(" "),
                          _c("h5", { staticClass: "builder-section-title" }, [
                            _vm._v(
                              "4. " +
                                _vm._s(
                                  _vm.$t(
                                    "mandate.report_builder.scheduling_distribution"
                                  )
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "6" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "mandate.report_builder.frequency"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.scheduleFrequency,
                                        expression: "scheduleFrequency",
                                      },
                                    ],
                                    staticClass: "filter-item-content w-100",
                                    staticStyle: { padding: "0.35rem" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.scheduleFrequency = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "on_demand" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.on_demand_only"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Quotidien" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.daily"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Hebdomadaire" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.weekly"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Mensuel" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.monthly"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "6" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mandate.report_builder.format")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.exportFormat,
                                        expression: "exportFormat",
                                      },
                                    ],
                                    staticClass: "filter-item-content w-100",
                                    staticStyle: { padding: "0.35rem" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.exportFormat = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "csv" } }, [
                                      _vm._v("CSV"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "excel" } },
                                      [_vm._v("Excel")]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "pdf" } }, [
                                      _vm._v("PDF"),
                                    ]),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "filter-item-title d-block mb-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.report_builder.recipients_comma_separated"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "mandate.report_builder.recipients_placeholder"
                                      ),
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.recipients,
                                      callback: function ($$v) {
                                        _vm.recipients = $$v
                                      },
                                      expression: "recipients",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center flex-wrap",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _vm.scheduleFrequency !== "on_demand"
                                    ? _c(
                                        "span",
                                        { staticClass: "next-run-info" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.report_builder.next_scheduled_run"
                                                )
                                              ) +
                                              ": "
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.nextRunLabel)),
                                          ]),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "next-run-info" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.report_builder.no_schedule_set"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btnFilter_2",
                                      on: { click: _vm.generateReport },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-play",
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.generate_now"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "7" } },
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center mb-3 flex-wrap",
                            },
                            [
                              _c(
                                "h5",
                                { staticClass: "builder-section-title mb-0" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "mandate.report_builder.live_preview"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-badge",
                                { attrs: { variant: "secondary" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedEmitter === "Tous"
                                        ? _vm.$t(
                                            "mandate.report_builder.all_emitters"
                                          )
                                        : _vm.selectedEmitter
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.selectedIndicators.length === 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center py-5",
                                },
                                [
                                  _c("span", { staticClass: "noResult" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "mandate.report_builder.select_indicator_preview"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "table-responsive" },
                                [
                                  _c("b-table", {
                                    staticClass: "mb-0",
                                    attrs: {
                                      striped: "",
                                      hover: "",
                                      small: "",
                                      items: _vm.previewItems,
                                      fields: _vm.previewFields,
                                    },
                                  }),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex justify-content-end",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btnFilter_2",
                                      attrs: {
                                        disabled:
                                          _vm.selectedIndicators.length === 0,
                                      },
                                      on: { click: _vm.exportPreview },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-upload",
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.report_builder.export_preview"
                                            )
                                          ) +
                                          " (" +
                                          _vm._s(
                                            _vm.exportFormat.toUpperCase()
                                          ) +
                                          ")\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.savedTemplates.length
                        ? _c("b-card", { staticClass: "mt-4" }, [
                            _c("h5", { staticClass: "builder-section-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "mandate.report_builder.saved_templates_by_emitter"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "table-responsive" },
                              [
                                _c("b-table", {
                                  staticClass: "mb-0",
                                  attrs: {
                                    striped: "",
                                    hover: "",
                                    small: "",
                                    items: _vm.savedTemplates,
                                    fields: _vm.savedTemplatesFields,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(frequency)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "b-badge",
                                              { attrs: { variant: "info" } },
                                              [_vm._v(_vm._s(data.value))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4136133746
                                  ),
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }